import { Box, Select, TextField } from 'vopay';
import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'UI';

type AccountBillingSearchParams = {
  type: string;
  currency: string;
  searchTerm: string;
};

type SearchFormProps = {
  type: string;
  currency: string;
  searchTerm: string;
  search: (searchParams: AccountBillingSearchParams) => void;
};

type FC = FunctionComponent<SearchFormProps>;

const BankSearchForm: FC = ({ type, currency, searchTerm, search }: SearchFormProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.MyBankAccounts.BankSearchForm' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const [currentType, setCurrentType] = useState<string>(type);
  const [currentCurrency, setCurrentCurrency] = useState<string>(currency);
  const [currentSearchTerm, setCurrentSearchTerm] = useState<string>(searchTerm);

  const typeOptions = [
    { value: 'All', label: t('TypeOptions.all', { defaultValue: 'All' }) },
    { value: 'BankAccount', label: t('TypeOptions.bankAccount', { defaultValue: 'Bank Account' }) },
    { value: 'CreditCard', label: t('TypeOptions.creditCard', { defaultValue: 'Credit Card' }) },
  ];

  const currencyOptions = [
    { value: 'All', label: t('CurrencyOptions.all', { defaultValue: 'All' }) },
    { value: 'CAD', label: 'CAD' },
    { value: 'USD', label: 'USD' },
  ];
  return (
    <Box jc="sb">
      <Box gapSize="8px">
        <Box width="200px">
          <Select
            version="2"
            placeholder={t('Placeholders.type', { defaultValue: 'Type' })}
            options={typeOptions}
            name="type"
            value={currentType}
            onBlur={() => {}}
            onChange={(e) => {
              setCurrentType(e.target.value);
            }}
          />
        </Box>
        <Box width="150px">
          <Select
            version="2"
            placeholder={t('Placeholders.currency', { defaultValue: 'Currency' })}
            options={currencyOptions}
            name="currency"
            value={currentCurrency}
            onBlur={() => {}}
            onChange={(e) => {
              setCurrentCurrency(e.target.value);
            }}
          />
        </Box>
      </Box>
      <Box gapSize="8px">
        <TextField
          key="AccountSearchKeyword"
          name="AccountSearchKeyword"
          placeholder={t('Placeholders.keyword', { defaultValue: 'Keyword' })}
          value={currentSearchTerm}
          onBlur={() => {}}
          onChange={(e) => {
            setCurrentSearchTerm(e.target.value);
          }}
          variant="outlineShadow"
        />
        <Button
          id="search-bankAccount"
          size="small"
          colorScheme="primary"
          onClick={() => {
            search({
              type: currentType,
              currency: currentCurrency,
              searchTerm: currentSearchTerm,
            });
          }}
        >
          {tGlobal('Buttons.search')}
        </Button>
      </Box>
    </Box>
  );
};

export default BankSearchForm;
